import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

class ProtectedRoute extends Component {
  render() {
    const { component: Component, token, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={(props) =>
          !!token ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: `/login`,
                state: { from: props.location },
              }}
            />
          )
        }
      />
    );
  }
}

export default connect(({ authReducer }) => {
  const { token } = authReducer;
  return { token };
})(ProtectedRoute);
